function Confirm({ confirm, closePopup, heading, description, yesText, noText, isError, error}) {
  // handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    confirm();
  };
  
  return (
    <form onSubmit={handleSubmit} className="confirm_remove">
      <h3>{heading}</h3>
      <p>{!isError ? description : error}</p>
      <div>
        <button className="form-default__cancel" onClick={closePopup}>
          {noText}
        </button>
        <button style={isError ? {display: "none"} : {}} className="form-default__submit" type="submit">
          {yesText}
        </button>
      </div>
    </form>
  );
}

export default Confirm;
